import type { FC } from "react";
import { Button } from "@similarweb/ui-components";
import { buttonTypes } from "app/UtilitiesAndConstants/Constants/ButtonTypes";
import type { ISegmentModal } from "app/pages/segments/redesigned-wizard/segment-wizard/types";
import { i18nFilter } from "app/filters/i18nFilter";
import { ProModal } from "pro-features/components/Modals/src/ProModal";
import {
    BlackDot,
    LabelTextWrapper,
    ModalButtonsWrapper,
    ModalContentWrapper,
    ModalLabelText,
    ModalLabelTextHint,
    ModalTitle,
    ModalDisclaimer,
    StyledCancelButton,
} from "app/pages/segments/redesigned-wizard/segment-wizard/segment-modals/segmentModalStyles";

export const SegmentModal: FC<ISegmentModal> = ({
    children,
    isOpen,
    isDisabledConfirmButton = false,
    onConfirm,
    onModalClose,
    modalTitle,
    modalText,
    modalHint,
    modalDisclaimer,
    modalConfirmButtonLabel,
    colorDisclaimer,
    confirmButtonType = buttonTypes.PRIMARY,
    cancelButtonType = buttonTypes.FLAT,
    modalWidth = 400,
}) => {
    const proModalStyles = {
        content: {
            top: "200px",
            marginTop: "0",
            width: `${modalWidth}px`,
            padding: "24px 16px 16px 24px",
        },
    };

    return (
        <ProModal
            isOpen={isOpen}
            onCloseClick={onModalClose}
            showCloseIcon={false}
            customStyles={proModalStyles}
        >
            <ModalContentWrapper>
                <ModalTitle>{i18nFilter()(modalTitle)}</ModalTitle>
                {modalText && (
                    <LabelTextWrapper>
                        <ModalLabelText>{i18nFilter()(modalText)}</ModalLabelText>
                        {modalHint && (
                            <>
                                <BlackDot />
                                <ModalLabelTextHint>{i18nFilter()(modalHint)}</ModalLabelTextHint>{" "}
                            </>
                        )}
                    </LabelTextWrapper>
                )}
                {children}
                <ModalDisclaimer
                    colorDisclaimer={colorDisclaimer}
                    isModalHintDisplayed={!!modalHint}
                    isModalTextDisplayed={!!modalText}
                >
                    {i18nFilter()(modalDisclaimer)}
                </ModalDisclaimer>
                <ModalButtonsWrapper isModalHintDisplayed={!!modalHint}>
                    <StyledCancelButton
                        label={i18nFilter()("segment.wizard.new.create.modal.button.cancel")}
                        type={cancelButtonType}
                        onClick={onModalClose}
                    />
                    <Button
                        label={i18nFilter()(modalConfirmButtonLabel)}
                        onClick={onConfirm}
                        type={confirmButtonType}
                        isDisabled={isDisabledConfirmButton}
                    />
                </ModalButtonsWrapper>
            </ModalContentWrapper>
        </ProModal>
    );
};
